import type { Addresses } from 'api/types/addresses.types';
import { AdapterAddressModule } from 'modes/adapters';
import AddressSheetContextProvider from 'packages/shared/newOrder/provider/AddressSheetContextProvider';
import { selectCurrentOrder } from 'pages/newOrder/newOrder.selectors';
import type { FC } from 'react';
import * as React from 'react';
import { useSelector } from 'react-redux';

interface AddressModuleWrapperProps {
  children?: React.ReactNode;
  show?: boolean;
  onSubmit: () => void;
  toggleAddressSheet: () => void;
  onEdit: (address?: Addresses.Address) => void;
  isLoading?: boolean;
  onClose: () => void;
  actionButtonProps?: {
    isLoading?: boolean;
  };
}

const AddressModuleWrapper: FC<AddressModuleWrapperProps> = ({
  children,
  show = false,
  onSubmit,
  toggleAddressSheet,
  onEdit,
  onClose,
  isLoading = false,
  actionButtonProps,
}) => {
  const { addressId } = useSelector(selectCurrentOrder);

  return (
    <AddressSheetContextProvider onContinue={onSubmit} onEdit={onEdit} toggleSheet={toggleAddressSheet}>
      {children}
      <AdapterAddressModule
        actionButtonProps={actionButtonProps}
        show={show}
        onClose={onClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        disabled={!addressId}
      />
    </AddressSheetContextProvider>
  );
};

export default AddressModuleWrapper;
